import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { AxiosError } from "axios";
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { ContextOperation } from "../../../context/OperationContext";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import useSnackbar from "../../../hooks/useSnackbar";
import OperationTypes from "../../../types";
import CheckInOutWrapper from "../../common/CheckInOutWrapper";
import FormInput from "../../common/FormInput";
import DamageFormService from "../service/DamageFormService";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";

type Props = {
  open: boolean;
  onClose: () => void;
}

const CreateDamageForm = (props: Props) => {
  const { setLoading, tenant, userLocations } = useContext(ContextOperation);
  const { globalData} = useContext(GlobalContext);

  const t = useOperationTranslation();
  const snackbar = useSnackbar();

  const [vehicle, setVehicle] = useState<OperationTypes.Vehicle | null>(null);

  const form = useForm<{plate: string}>();

  const onSubmit = (data: {plate: string}) => {
    setLoading(true)
    DamageFormService.list.getVehicleByPlate(tenant, data.plate).then(
      response => {
        setLoading(false);
        
        //Ci hanno chiesto di togliere questi controlli
        //if(response.physicalLocationId === null || response.physicalLocationId === undefined) {
        //  snackbar.show("warning", t("damageForm.dialogs.create.warningVehicleTransfering"))
        //  return;
        //}

        //if(!userLocations.map(loc => loc.id).includes(response.physicalLocationId)) {
        //  snackbar.show("warning", t("damageForm.dialogs.create.warningNotInLocation").replace("#textElement", globalData.user.username))
        //}

        setVehicle(response);
      },
      (error: AxiosError) => {
        setLoading(false);

        console.log(error);
        if (error?.response?.status === 404) {
          snackbar.show("error", t("damageForm.dialogs.create.errorNotFound"));
        } else {
          snackbar.show("error", t("damageForm.dialogs.create.errorGeneralError"));
        }
      }
    );
  }

  const onConfirm = () => {
    setVehicle(null);
    form.reset();
    props.onClose();
  }

  const onClose = () => {
    setVehicle(null);
    form.reset();
    props.onClose();
  }


  return (
    <Mui.Dialog
      open={props.open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
    >
      <Mui.DialogTitle>
        
        <Mui.Grid container spacing={1}>
          <Mui.Grid item>
              <Mui.Typography variant="h5">
                {t("damageForm.dialogs.create.title")}
              </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid item marginLeft={"auto"}>
            <Mui.IconButton onClick={onClose}>
                <MuiIcons.Close />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>

      <Mui.DialogContent>
        <Mui.Box>
          {!vehicle && (
            <form id="vehicle-check-search" onSubmit={form.handleSubmit(onSubmit)}>
              <Mui.Box height="calc(100vh - 48px - 88px - 32px)" padding={{ md: 2, xs:0 }}>
                <Mui.Card style={{ height: "100%" }}>
                  <Mui.CardContent style={{ height: "100%" }}>
                    <Mui.Stack height="calc(100% - 32px)">
                      <Mui.Typography variant="h4" textAlign="center" mb={2}>
                        {t("damageForm.dialogs.create.cardTitle")}
                      </Mui.Typography>
                      
                      <Mui.Typography variant="body" whiteSpace="pre-line" textAlign="center" mb="80px">
                        {t("damageForm.dialogs.create.cardSubtitle")}
                      </Mui.Typography>
                      
                      <Mui.Grid container  columns={12} p="0px 16px" mb="25px" spacing={2}>
                        <Mui.Grid 
                          item 
                          xl={12} 
                          lg={12} 
                          md={12} 
                          xs={12}
                        >
                          <FormInput
                            name="plate"
                            type="text"
                            label={t("damageForm.dialogs.create.inputPlateLabel")}
                            placeholder={t("damageForm.dialogs.create.inputPlatePlaceholder")}
                            fullWidth
                            formInstance={form}
                          />
                        </Mui.Grid>
                      </Mui.Grid>

                      <Mui.Stack direction="row" alignItems="center" justifyContent="center" mb="25px">
                        <Mui.Typography variant="body">
                        {t("damageForm.dialogs.create.cardQrCode")}
                        </Mui.Typography>
                        <MuiIcons.InfoOutlined style={{ marginLeft: "5px" }} />
                      </Mui.Stack>

                      <Mui.Button variant="contained" color="accent" disabled={true} style={{ margin: "0px 16px"}}>
                        {t("damageForm.dialogs.create.btnQrCode")} <MuiIcons.QrCode />
                      </Mui.Button>

                      <Mui.Button variant="contained" color="accent" type="submit" style={{ margin: "auto 16px 0px 16px" }}>
                        {t("damageForm.dialogs.create.btnContinue")}
                      </Mui.Button>
                    </Mui.Stack>
                  </Mui.CardContent>
                </Mui.Card>
              </Mui.Box>
            </form>
          )}

          {vehicle && (
            <CheckInOutWrapper
              brandDescription={vehicle.model.brand.descr}
              callbackButtonLabel={t("damageForm.dialogs.create.btnConfirm")}
              currentBatteryPercentage={vehicle.currentElectricTankFilling}
              currentFuelLevelEighths={vehicle.currentTermicTankFilling}
              currentKms={vehicle.kms}
              enginePowerGroupCode={vehicle.enginePowerCode}
              modelDescription={vehicle.model.descr}
              oprCallback={onConfirm}
              plate={vehicle.plate}
              carClass={vehicle.carClass.descr}
              bypassDamagesEquipments={false}
            />
          )}
        </Mui.Box>
      </Mui.DialogContent>
    </Mui.Dialog>
  )
}

export default CreateDamageForm